export default "__VITE_ASSET__Bz5ZxvU7__"